<template>
  <section class="info">
    <div class="container">
      <div class="info__wrap">
        <div class="info__head">
          <h2 class="h1-title info__title">What a.sk is</h2>
          <p class="info__description">
            Skip the search results and the forum threads. Ask your question, get a straight answer, instantly.
          </p>
        </div>
        <ul class="info__list">
          <li class="info__item">
            <svg width="85" height="85" viewBox="0 0 85 85" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle class="info__item-cirle" cx="42.5" cy="42.5" r="42.5" />
              <path
                d="M64.5764 73.1611C65.6438 73.1611 66.5172 72.2878 66.5172 71.2204C66.5172 70.153 65.6438 69.2796 64.5764 69.2796H60.6951V58.8776C60.6951 56.9078 59.8412 55.0351 58.3664 53.7445L48.7018 45.2928C48.0516 44.7299 47.7024 43.944 47.7024 43.0804C47.7024 42.2168 48.0615 41.4309 48.7018 40.868L58.3664 32.4163C59.851 31.1257 60.6951 29.253 60.6951 27.2832V16.8812H64.5764C65.6438 16.8812 66.5172 16.0078 66.5172 14.9404C66.5172 13.873 65.6437 13 64.5764 13H60.6951H23.8221H19.9407C18.8733 13 18 13.8733 18 14.9407C18 16.0081 18.8733 16.8815 19.9407 16.8815H23.8221V28.2345C23.8221 30.214 24.676 32.0964 26.1801 33.387L34.7966 40.8586C35.4468 41.4215 35.8156 42.2171 35.8156 43.0807C35.8156 43.9443 35.4565 44.7399 34.7966 45.3028L26.1801 52.7647C24.676 54.065 23.8221 55.9474 23.8221 57.9269V69.28H19.9407C18.8733 69.28 18 70.1533 18 71.2207C18 72.2881 18.8733 73.1614 19.9407 73.1614H23.8221H60.695H64.5764V73.1611ZM56.8136 69.2798H27.7034V57.9267C27.7034 57.0728 28.0722 56.2675 28.7126 55.7047L37.3292 48.2428C38.8235 46.9425 39.6872 45.0698 39.6872 43.0903C39.6872 41.1107 38.8332 39.2283 37.3292 37.9377L28.7126 30.4662C28.0722 29.9033 27.7034 29.0883 27.7034 28.2344V16.8813H56.8136V27.2833C56.8136 28.1275 56.4449 28.9328 55.8044 29.4957L46.1398 37.9474C44.6648 39.238 43.8111 41.1107 43.8111 43.0806C43.8111 45.0504 44.665 46.9231 46.1398 48.2137L55.8141 56.6654C56.4545 57.2283 56.8135 58.0336 56.8135 58.8778L56.8136 69.2798Z"
                fill="url(#paint0_linear_90_908)"
              />
              <path
                d="M44.6941 49.0773C43.6558 48.1652 42.802 47.0396 42.3361 45.7393C42.0354 44.9048 41.9092 44.0607 41.8898 43.2262C41.8898 43.1777 41.8898 43.0806 41.8898 43.0806H41.6084V43.2165C41.5696 45.4289 40.609 47.5151 38.94 48.9707L30.3234 56.4422C29.8964 56.8207 29.6442 57.3543 29.6442 57.9269V66.4756C29.6442 66.951 30.0323 67.3392 30.5078 67.3392H54.0095C54.4849 67.3392 54.8731 66.951 54.8731 66.4756V58.8778C54.8731 58.3052 54.6305 57.7716 54.2036 57.3931L44.6941 49.0773Z"
                fill="url(#paint1_linear_90_908)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_90_908"
                  x1="37.5"
                  y1="11"
                  x2="37.5"
                  y2="85.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#D9D9D9" />
                  <stop offset="1" stop-color="#224EFE" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_90_908"
                  x1="39.7842"
                  y1="42.2741"
                  x2="39.7842"
                  y2="72.3145"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#D9D9D9" />
                  <stop offset="1" stop-color="#224EFE" />
                </linearGradient>
              </defs>
            </svg>
            <p class="info__subtitle">Instant</p>
          </li>
          <li class="info__item">
            <svg width="85" height="86" viewBox="0 0 85 86" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle class="info__item-cirle" cx="42.5" cy="42.5845" r="42.5" />
              <path
                d="M41.7906 18.1035C28.6901 18.1035 18.0186 28.7751 18.0186 41.8756C18.0186 54.9761 28.6901 65.6685 41.7906 65.6685C47.3863 65.6685 52.5325 63.7075 56.5998 60.4516L66.5018 70.3484C67.0015 70.8274 67.669 71.0917 68.3611 71.0846C69.0533 71.0776 69.7152 70.7998 70.205 70.3106C70.6948 69.8215 70.9736 69.1601 70.9816 68.468C70.9896 67.7758 70.7263 67.108 70.248 66.6076L60.346 56.7056C63.6045 52.6321 65.5679 47.4777 65.5679 41.8756C65.5679 28.7751 54.8912 18.1035 41.7906 18.1035ZM41.7906 23.3874C52.0356 23.3874 60.2789 31.6307 60.2789 41.8756C60.2789 52.1205 52.0356 60.3846 41.7906 60.3846C31.5457 60.3846 23.3024 52.1205 23.3024 41.8756C23.3024 31.6307 31.5457 23.3874 41.7906 23.3874Z"
                fill="url(#paint0_linear_225_283)"
              />
              <path
                d="M51.666 35.6598C50.899 34.8927 49.6569 34.8927 48.89 35.6598L40.339 44.2107L36.3606 40.184C35.5982 39.4124 34.3554 39.4046 33.5838 40.1669C32.8122 40.9293 32.8044 42.1721 33.5667 42.9437L38.9331 48.3756C39.3009 48.7481 39.801 48.958 40.3238 48.9594C40.3258 48.9594 40.3278 48.9594 40.3296 48.9594C40.8499 48.9594 41.3499 48.7526 41.7183 48.3836L51.6658 38.4361C52.4331 37.6695 52.4331 36.4261 51.666 35.6598Z"
                fill="#D9D9D9"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_225_283"
                  x1="39.3055"
                  y1="16.3422"
                  x2="39.3055"
                  y2="81.9508"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#D9D9D9" />
                  <stop offset="1" stop-color="#224EFE" />
                </linearGradient>
              </defs>
            </svg>
            <p class="info__subtitle">Reliable</p>
          </li>
          <li class="info__item">
            <svg width="85" height="85" viewBox="0 0 85 85" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle class="info__item-cirle" cx="42.5" cy="42.5" r="42.5" />
              <path
                d="M41.9293 71.1921C30.1104 71.1921 21 62.328 21 50.7553C21 46.5694 21.7387 43.3685 23.216 40.9062C24.6934 38.6902 25.4321 37.7053 26.6632 36.4741C27.1557 36.2279 27.4019 35.7355 27.8944 35.243L28.633 34.2581C29.8642 33.027 30.1104 32.7807 31.3415 30.5647C32.5727 28.3486 33.5576 23.1779 33.5576 19.4845C33.5576 18.4996 34.05 17.7609 35.0349 17.2684C35.7736 16.776 36.7585 17.0222 37.4972 17.5147L38.7283 18.4996C41.4368 20.4694 44.884 23.4241 47.5925 27.61C49.3161 30.3185 51.0397 34.0119 52.0246 36.9666C52.5171 35.9817 53.0095 34.7505 53.2557 33.2732C53.502 32.2883 54.2406 31.3034 55.2255 31.0571C56.2105 30.8109 57.4416 31.3034 57.934 32.2883C59.6576 35.243 59.9039 35.7355 61.3812 40.1675C62.8586 44.8459 63.1048 47.8006 63.1048 50.5091C62.8586 61.8355 53.502 71.1921 41.9293 71.1921ZM37.9897 24.409C37.4972 27.61 36.7585 30.8109 35.5274 33.027C34.05 35.4892 33.5576 36.2279 32.3264 37.7053L31.5878 38.444C31.0953 38.9364 30.6029 39.4289 30.3566 39.9213C29.3717 41.1524 28.633 41.8911 27.4019 43.6147C26.417 45.3383 25.9245 47.8006 25.9245 51.0015C25.9245 59.6195 33.0651 66.5138 41.9293 66.5138C50.7935 66.5138 57.934 59.3732 57.934 50.5091C57.934 48.0468 57.934 45.8308 56.4567 41.8911C56.2105 41.1524 55.9642 40.66 55.9642 40.1675C54.7331 42.1374 53.2557 43.3685 52.5171 43.8609C51.7784 44.3534 50.7935 44.5996 49.8086 44.1072C49.0699 43.6147 48.3312 42.876 48.3312 41.8911C48.3312 41.1524 46.3614 34.5043 43.6529 30.3185C41.9293 27.8562 39.9595 25.8864 37.9897 24.409Z"
                fill="url(#paint0_linear_90_585)"
              />
              <path
                d="M31.5002 58.9999C32.3864 62.1007 35.0004 65.0002 41.0002 64.9999C47 64.9997 51.5 60.5001 53 58.0001C56.8243 51.6263 55.5 49.0001 55.5 49.0001C54.5 49.7085 52 51.0002 49.5 51.5001C42 53 38.4999 44.4999 38 44.9999C35.8726 47.1279 29.4998 52.0001 31.5002 58.9999Z"
                fill="url(#paint1_linear_90_585)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_90_585"
                  x1="37.9228"
                  y1="15.1984"
                  x2="37.9228"
                  y2="82.3065"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#D9D9D9" />
                  <stop offset="1" stop-color="#224EFE" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_90_585"
                  x1="41.0059"
                  y1="44.3131"
                  x2="41.0059"
                  y2="69.1061"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#D9D9D9" />
                  <stop offset="1" stop-color="#224EFE" />
                </linearGradient>
              </defs>
            </svg>
            <p class="info__subtitle">Any topic</p>
          </li>
          <li class="info__item">
            <svg width="85" height="85" viewBox="0 0 85 85" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle class="info__item-cirle" cx="42.5" cy="42.5" r="42.5" />
              <path
                d="M60.8253 60.9996L58.4689 53.9101C58.0781 52.7342 56.817 52.1009 55.6536 52.4956C54.4897 52.8904 53.8627 54.1632 54.2531 55.339L56.6046 62.4149C56.9112 63.386 56.2629 63.9535 56.0561 64.1044C55.7952 64.2956 55.1029 64.6776 54.3152 64.0978L45.5855 57.7088C43.4984 56.1719 40.6935 56.1719 38.5981 57.7149L29.871 64.2013C29.0885 64.7776 28.3967 64.3956 28.1357 64.2044C27.9286 64.0526 27.2772 63.4825 27.5911 62.5022L30.9268 52.0382C31.7215 49.5592 30.8564 46.8632 28.7776 45.3325L20.0739 38.8978C19.2858 38.3175 19.4312 37.5417 19.5302 37.2346C19.6293 36.9268 19.9662 36.2105 20.9438 36.2105H31.7058C34.275 36.2105 36.5423 34.5219 37.3496 32.0048L40.6848 21.5342C40.9866 20.593 41.7722 20.4912 42.0961 20.4912C42.4197 20.4912 43.2057 20.593 43.5062 21.5303L46.844 32.0088C47.6496 34.5219 49.9173 36.2105 52.486 36.2105H63.3184C64.296 36.2105 64.633 36.9268 64.732 37.2351C64.831 37.5417 64.9765 38.318 64.1857 38.9L58.2727 43.268C57.2817 44.0004 57.0658 45.4053 57.7906 46.4066C58.5154 47.4075 59.9068 47.625 60.8978 46.893L66.8078 42.5272C68.9227 40.9697 69.7677 38.3465 68.96 35.8434C68.1518 33.3382 65.9375 31.7193 63.3184 31.7193H52.486C51.8615 31.7193 51.2809 31.2693 51.076 30.6294L47.7382 20.1509C46.9296 17.6294 44.7152 16 42.0961 16C39.4771 16 37.2623 17.6294 36.4524 20.1548L33.1172 30.6254C32.9109 31.2693 32.3303 31.7193 31.7058 31.7193H20.9438C18.3247 31.7193 16.1099 33.3382 15.3018 35.8434C14.4945 38.3465 15.3391 40.9702 17.4505 42.5246L26.1541 48.9592C26.6796 49.3456 26.8972 50.0272 26.6948 50.6583L23.3592 61.1224C22.5497 63.6482 23.4004 66.2855 25.5266 67.8417C26.5819 68.6136 27.79 69 28.999 69C30.2163 68.9996 31.4349 68.6083 32.4988 67.8246L41.2259 61.3382C41.7461 60.9548 42.4453 60.9548 42.9708 61.3417L51.7009 67.7307C53.814 69.2864 56.5473 69.2908 58.6652 67.7417C60.7914 66.186 61.6421 63.5482 60.8322 61.0228C60.8301 61.0149 60.8279 61.0075 60.8253 60.9996Z"
                fill="url(#paint0_linear_90_594)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_90_594"
                  x1="36.8089"
                  y1="14.2381"
                  x2="36.8089"
                  y2="79.8698"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#D9D9D9" />
                  <stop offset="1" stop-color="#224EFE" />
                </linearGradient>
              </defs>
            </svg>
            <p class="info__subtitle">Free</p>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script></script>

<style scoped lang="scss">
.info {
  &__wrap {
    border-radius: 30px;
    padding: 125px 107px 95px 107px;
    background-color: #d9d9d9;
  }

  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 102px;
  }

  &__title {
    margin-right: 30px;
    max-width: 390px;
    width: 100%;
    color: var(--theme-color-1);
    text-align: right;
  }

  &__description {
    max-width: 860px;
    line-height: 1.5;
    color: #121416;
    opacity: 0.6;
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 35px;
    margin-bottom: 0;
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 2px solid rgba(74, 76, 77, 0.6);
    border-radius: 30px;
    padding: 27px 30px 30px 30px;
    max-width: calc(25% - 32px);
    width: 100%;

    &:hover {
      & :is(.info__item-cirle) {
        fill: #27292d;
      }

      & :is(.info__subtitle) {
        color: #27292d;
      }
    }

    & :is(.info__item-cirle) {
      fill: var(--theme-color-1);
      transition: 0.3s fill ease-in-out;
    }
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 85px;
    height: 85px;
    background-color: var(--theme-color-1);
  }

  &__subtitle {
    font-size: 2.8rem;
    font-weight: 500;
    line-height: 1.5;
    color: var(--theme-color-1);
    transition: 0.3s color ease-in-out;
  }

  &__secondary-title {
    margin-bottom: 36px;
    text-align: center;
    color: #27292d;

    & :is(span) {
      font-size: inherit;
      line-height: inherit;
      color: var(--theme-color-1);
    }
  }

  &__text {
    margin: 0 auto 40px auto;
    max-width: 900px;
    color: rgba(74, 76, 77, 0.6);
    line-height: 1.5;
    text-align: center;
  }

  &__img {
    display: block;
    max-width: 880px;
    width: 100%;
    margin: 0 auto;
  }
}

@media screen and (max-width: 1440px) {
  .info {
    &__wrap {
      padding: 93px 50px 80px 51px;
    }

    &__head {
      justify-content: center;
      gap: 55px;
      margin-bottom: 92px;
    }

    &__description {
      max-width: 490px;
    }

    &__list {
      justify-content: center;
      gap: 40px;
    }

    &__item {
      text-align: center;
      padding: 30px 45px;
    }

    &__item:nth-child(4) {
      margin-left: 0;
    }
  }
}

@media screen and (max-width: 991px) {
  .info {
    &__wrap {
      padding: 66px 35px 20px 30px;
    }

    &__head {
      margin-bottom: 60px;
      gap: 65px;
    }

    &__title {
      display: block;
      margin-right: 0;
      max-width: none;
      width: 100%;
    }

    &__description {
      max-width: 380px;
    }

    &__list {
      gap: 28px 17px;
    }

    &__item {
      max-width: calc(50% - 10px);
    }

    &__secondary-title {
      margin-bottom: 6px;
    }
  }
}

@media screen and (max-width: 560px) {
  .info {
    &__wrap {
      padding: 50px 15px 20px 15px;
    }

    &__head {
      flex-direction: column;
      gap: 23px;
      margin-bottom: 30px;
    }

    &__title {
      text-align: left;
    }

    &__list {
      gap: 13px 8px;
    }

    &__item {
      padding: 14px 17px;
      max-width: calc(50% - 4px);
    }

    &__subtitle {
      font-size: 1.8rem;
    }

    &__secondary-title {
      margin-bottom: 15px;
    }

    &__text {
      margin-bottom: 25px;
    }
  }
}
</style>
